const transformCustomerCustomAttributes = (custom_attributes)=>{
    if (!custom_attributes || !Array.isArray(custom_attributes)) {
        return {};
    }
    return custom_attributes.reduce((acc, { attribute_code , value  })=>{
        return {
            ...acc,
            [`custom_attribute_${attribute_code}`]: value
        };
    }, {});
};
const transformCustomerCustomAttributesRequest = (attributes)=>{
    if (!attributes || !Object.keys(attributes).length) {
        return [];
    }
    return Object.keys(attributes)?.reduce((acc, key)=>{
        if (key.startsWith('custom_attribute_')) {
            const value = attributes[key];
            if (value !== null && value !== undefined && value !== '') {
                const attribute_code = key.replace('custom_attribute_', '');
                return [
                    ...acc,
                    {
                        attribute_code,
                        value
                    }
                ];
            }
        }
        return acc;
    }, []);
};
const transformCustomerAddress = ({ id =null , entity_id =null , firstname , lastname , street , postcode , city , region , region_id , country_id , telephone , company , default_shipping =false , default_billing =false , custom_attributes  } = {})=>({
        id: id || entity_id || null,
        firstname,
        lastname,
        street: typeof street === 'string' ? [
            street
        ] : street,
        postcode,
        city,
        regionText: region?.region ?? null,
        regionCode: region?.region_code ?? null,
        regionId: region_id ? region_id : null,
        countryCode: country_id,
        telephone,
        company: company || null,
        defaultShipping: default_shipping,
        defaultBilling: default_billing,
        ...transformCustomerCustomAttributes(custom_attributes)
    });
const transformCustomer = ({ id , email , firstname , lastname , dob , addresses , group_id , additional_info , taxvat , gender  })=>({
        id,
        firstname,
        lastname,
        dob: dob || null,
        gender: gender === 1 ? 'man' : gender === 2 ? 'woman' : null,
        email,
        addresses: addresses.map((address)=>transformCustomerAddress(address)),
        groupId: group_id,
        attributes: additional_info,
        taxvat: taxvat || null
    });
const transformCustomerAddressRequest = ({ id , firstname , lastname , street =[] , postcode , city , regionId , regionText , countryCode , telephone , //company,
...rest } = {})=>{
    const customAttributes = transformCustomerCustomAttributesRequest(rest);
    return {
        id,
        firstname,
        lastname,
        street: street.join(' ').trim(),
        postcode,
        city,
        region: regionId ? {
            region_id: regionId
        } : {
            region: regionText
        },
        country_id: countryCode,
        telephone,
        //company,
        ...customAttributes.length ? {
            custom_attributes: customAttributes
        } : {}
    };
};
const transformCustomerAddressEasyReturnRequest = ({ id , firstname , lastname , street =[] , postcode , city , regionId , regionText , countryCode , telephone , //company,
...rest } = {})=>{
    const customAttributes = transformCustomerCustomAttributesRequest(rest);
    return {
        id,
        firstname,
        lastname,
        street: street.join(' ').trim(),
        postcode,
        city,
        region: regionText,
        region_id: regionId,
        country_id: countryCode,
        telephone,
        //company,
        ...customAttributes.length ? {
            custom_attributes: customAttributes
        } : {}
    };
};

export { transformCustomer, transformCustomerAddress, transformCustomerAddressEasyReturnRequest, transformCustomerAddressRequest, transformCustomerCustomAttributes, transformCustomerCustomAttributesRequest };
